import React, { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { withRouter, RouteComponentProps } from "react-router";
import { runInAction } from "mobx";
import { UI } from "@wwimmo/ui";
import { selectRoute, Route } from "src/config/routes";
import { RootStoreContext } from "src/stores/RootStore";

const TicketingSettingsBase = (props: RouteComponentProps) => {
    const { t } = useTranslation();
    const { navStore, uiSidebarStore } = useContext(RootStoreContext);

    useEffect(() => {
        runInAction(() => {
            navStore.setTitle(t("screens.ticketing_settings.title"));
            navStore.setActionButtonMiddle(null);
            navStore.setActionButtonRight(null);

            if (uiSidebarStore.isSidebarActive) {
                navStore.setBackbutton(null);
            } else {
                navStore.setBackbutton(selectRoute(Route.profile), t("screens.account.title").toString());
            }
        });
    }, [navStore, t, uiSidebarStore.isSidebarActive]);

    return (
        <UI.Container className="pt-4">
            <UI.Row>
                <UI.Col xs={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
                    <UI.Card title={t("screens.ticketing_settings.title").toString()}>
                        <span>
                            <Trans
                                i18nKey="screens.ticketing_settings.moved_notice"
                                components={{
                                    1: (
                                        <Link
                                            style={{ display: "inline" }}
                                            to={{
                                                pathname: Route.communicationSettings,
                                                search: "?tab=easycontact-ticketing"
                                            }}
                                        />
                                    )
                                }}
                            />
                        </span>
                    </UI.Card>
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};

export const TicketingSettings = withRouter(Sentry.withProfiler(observer(TicketingSettingsBase)));
